import React from 'react';
import { string, object, element } from 'prop-types';
import { IntlProvider } from 'react-intl';

const LanguageProvider = ({ messages, locale, children }) => (
  <IntlProvider locale={locale} key={locale} messages={messages[locale]}>
    {React.Children.only(children)}
  </IntlProvider>
);

LanguageProvider.propTypes = {
  locale: string,
  messages: object,
  children: element.isRequired,
};

export default LanguageProvider;
